import type { DocLinkSlug } from "../../../../../components/react/docLink/AllDocLinkSlugs";

export const SILENCING_DOC_LINK_SLUG = "ui-monitors-silencing" satisfies DocLinkSlug;
